module.exports = __webpack_public_path__ + "img/4-images-tt.97156b86.png";